import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {Component,OnDestroy,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {JhiAlertService,JhiEventManager,JhiParseLinks} from 'ng-jhipster';
import {Subscription} from 'rxjs';

import {Principal} from 'src/app/core';
import {IVesselInformationMySuffix} from 'src/app/shared/model/vessel-information-my-suffix.model';

import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';
import {VesselInformationMySuffixService} from './vessel-information-my-suffix.service';

import {Observable} from 'rxjs';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';

@Component({
    selector: 'jhi-vessel-information-my-suffix',
    templateUrl: './vessel-information-my-suffix.component.html'
})
export class VesselInformationMySuffixComponent implements OnInit, OnDestroy {
    currentAccount: any;
    vesselInformations: IVesselInformationMySuffix[];
    error: any;
    success: any;
    eventSubscriber: Subscription;
    routeData: any;
    links: any;
    totalItems: any;
    queryCount: any;
    itemsPerPage: any;
    page: any;
    predicate: any;
    previousPage: any;
    reverse: any;

    vesselInformationList = [];
    isSaving: boolean;

    listCount = 0;
    listSize: number;
    extractedVesselList = [];
    searchText: string;
    flag: boolean;
    isShowPastHistory: boolean;
    isShowFutureHistory: boolean;
    constructor(
        private vesselInformationService: VesselInformationMySuffixService,
        private parseLinks: JhiParseLinks,
        private jhiAlertService: JhiAlertService,
        public principal: Principal,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private eventManager: JhiEventManager,
        private languageChangeService:LanguageChangeService,
    ) {
        this.itemsPerPage = ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(data => {
            this.page = data.pagingParams.page;
            this.previousPage = data.pagingParams.page;
            this.reverse = data.pagingParams.ascending;
            this.predicate = data.pagingParams.predicate;
            // if(this.itemsPerPage == 25 && this.page >1){
            //     this.page =1;
            // }
        });
                this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            if (paramMap.get('size')) {
                this.itemsPerPage = paramMap.get('size');
            }
            const refresh = paramMap.get('refresh');
            if (refresh) {
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
        
    }

    loadAll() {
        this.vesselInformationService
            .query({
                page: this.page - 1,
                size: this.itemsPerPage,
                sort: this.sort()
            })
            .subscribe(
                (res: HttpResponse<IVesselInformationMySuffix[]>) => this.paginateVesselInformations(res.body, res.headers),
                (res: HttpErrorResponse) => this.onError(res.message)
            );
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    transition() {
        if (this.searchText) {
            this.searchItems();
            this.flag = true;
        } else {
            this.router.navigate(['/data-management/vessel-information'], {
                queryParams: {
                    page: this.page,
                    size: this.itemsPerPage,
                    sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
                }
            });
            this.loadAll();
        }
    }

    clear() {
        this.page = 0;
        this.router.navigate([
            '/data-management/vessel-information',
            {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        ]);
        this.loadAll();
    }
    addZeroPadding:boolean;
    ngOnInit() {
        this.principal.setTitle("Vessel Information");
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.loadAll();
        this.principal.identity().then(account => {
            this.currentAccount = account;
            if (this.currentAccount.userRole != "BROKER" && this.currentAccount.userRole != "BROKER_STAFF") {
                this.addZeroPadding = true;
            } else {
                this.addZeroPadding = false;
            }
        });
        this.registerChangeInVesselInformations();
    }

    ngOnDestroy() {
        if (this.eventSubscriber) 
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId(index: number, item: IVesselInformationMySuffix) {
        return item.id;
    }

    registerChangeInVesselInformations() {
        this.eventSubscriber = this.eventManager.subscribe('vesselInformationListModification', response => this.loadAll());
    }

    sort() {
        const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    }

    private paginateVesselInformations(data: IVesselInformationMySuffix[], headers: HttpHeaders) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.queryCount = this.totalItems;
        this.vesselInformations = data;
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage, null, null);
    }

    public uploadFile(event) {
        let $this = this;
        let files = event.target.files; // FileList object
        let file = files[0];

        let formData = new FormData();
        formData.append('file', file);
        this.vesselInformationService.uploadVesselInfoService(formData).subscribe(response => {
            console.log(response.body);
            this.loadAll();
        });

        // let reader = new FileReader();
        // reader.readAsText(file);

        // reader.onload = function(e) {
        //     if (e.target !== null) {
        //         let csv = reader.result; // Content of CSV file
        //         $this.extractData(csv); //Here you can call the above function.
        //     }
        // };
    }

    public extractData(data) {
        // Input csv data to the function

        let csvData = data;
        let allTextLines = csvData.split(/\r\n|\n/);
        let headers = allTextLines[0].split(',');
        let lines = [];

        for (let i = 0; i < allTextLines.length; i++) {
            // split content based on comma
            //   console.log("xlsx data", data);
            let data = allTextLines[i].split(';');
            this.vesselInformationList.push({
                id: null,
                imoNumber: data[0],
                name: data[1],
                category: 'N/A',
                sttaus: data[6],
                yearOfBuilt: '',
                classicficationSociety: data[2],
                pAndIClub: 'N/A',
                dateOfNextSurvey: data[4],
                activeStatus: 'ACTIVE'
            });
        }
        const size = 1000;
        const newArrayList = new Array(Math.ceil(this.vesselInformationList.length / size)).fill('').map(function () {
            return this.splice(0, size);
        }, this.vesselInformationList.slice());
        this.extractedVesselList = newArrayList;
        this.listSize = this.extractedVesselList.length;
        this.sequenceOfVesselInformation();
    }

    sequenceOfVesselInformation() {
        if (this.listCount <= this.listSize) {
            this.save(this.extractedVesselList[this.listCount]);
        }
    }

    save(data) {
        this.isSaving = true;
        if (data.length > 0) {
            this.subscribeToSaveResponse(this.vesselInformationService.createAll(data));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IVesselInformationMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<IVesselInformationMySuffix>) => this.onSaveSuccess(),
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.listCount++;
        if (this.listCount <= this.listSize) {
            this.sequenceOfVesselInformation();
        } else {
            this.previousState();
        }
    }

    private onSaveError() {
        this.isSaving = false;
    }

    previousState() {
        window.history.back();
    }
    searchItems() {
        if (this.searchText) {
            var pNo = 0;
             var size = this.itemsPerPage;
            if (this.flag == true) {
                pNo = this.page - 1;
                size = this.itemsPerPage;
                this.flag = false;
            }
            this.principal
                .searchQuery(this.searchText, 'vessel-informations/search', {
                    page: pNo,
                    size: size,
                    sort: this.sort()
                })
                .subscribe(
                    (res: HttpResponse<IVesselInformationMySuffix[]>) => this.paginateVesselInformations(res.body, res.headers),
                    (res: HttpErrorResponse) => this.onError(res.message)
                );
        } else {
            this.loadAll();
        }
    }

    // history
    parentHistoryToggle = false;
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Vessel Informations (' + Obj.imoNumber + ') History';
        this.historyType = "VESSEL_INFORMATION_AUDIT";
        this.historyId = Obj.id;
    }
    onChange(value){
        this.page = 0;
        this.itemsPerPage=value
        this.loadAll();
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            // this.parentFutureHistoryToggle = false;
        }
    }
}
